import { gql } from "@apollo/client";

export const listB2bProducts = gql`
  query ListB2bProducts($filters: KeywordGroupFilter) {
    listKeywordGroups(type: "B2B_PRODUCT", filters: $filters) {
      id
      name
      type
      slug
      category
      metadata
    }
  }
`;
